import styled, { css } from 'styled-components';
import { theme, toRem } from 'design';

interface ButtonAddProps {
  width?: number;
  isAdded?: boolean;
  disabled?: boolean;
}

const ButtonAdd = styled.button<ButtonAddProps>`
  position: relative;
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  width: auto;
  height: ${toRem(theme.button.height.small)};
  padding: 0 ${toRem(16.5)};
  border-radius: ${toRem(theme.button.height.small / 2)};
  border: ${toRem(1)} solid ${theme.color.neutral[200]};
  background-color: ${theme.color.neutral[100]};
  font-family: ${theme.font.family.euclid};
  font-weight: ${theme.font.weight.semiBold};
  font-size: ${toRem(11)};
  color: ${theme.color.neutral[900]};
  transition: background-color ${theme.transition.button.default};

  &:hover {
    background-color: ${theme.color.neutral[100]};
  }

  ${({ width }) =>
    width &&
    css`
      width: ${toRem(width)};
    `}

  ${({ isAdded }) =>
    isAdded &&
    css`
      border-color: ${theme.color.secondary[300]};
      background-color: ${theme.color.secondary[300]};
      color: ${theme.color.white};

      &:hover {
        background-color: ${theme.color.secondary[400]};
      }
    `}

  ${({ disabled }) =>
    disabled &&
    css`
      background-color: #e8e8e8;
      color: ${theme.color.neutral[700]};
      cursor: auto;

      &:hover {
        background-color: #e8e8e8;
      }
    `}
`;

export default ButtonAdd;
